import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui';
import { PATHS } from '../constants/Paths';

/**
 * 404 page.
 *
 * Unknown URLs previously redirected silently to the marketing landing page -
 * for a signed-in user mid-task (a mistyped scan id, a stale bookmark) that
 * reads as being logged out, which is far more alarming than a plain 404.
 */
export default function NotFound() {
	const navigate = useNavigate();
	return (
		<div className="min-h-screen bg-muted flex items-center justify-center p-6">
			<div className="text-center max-w-sm">
				<p className="text-sm font-medium text-brand-600">404</p>
				<h1 className="mt-2 text-2xl font-semibold text-foreground">Page not found</h1>
				<p className="mt-2 text-sm text-muted-foreground">
					The page you're looking for doesn't exist or may have moved.
				</p>
				<div className="mt-6 flex items-center justify-center gap-3">
					{/* Plain buttons: this app's Button renders extra internal nodes,
					    so Radix Slot's single-child contract (asChild) crashes. */}
					<Button onClick={() => navigate(PATHS.DASHBOARD)}>Go to dashboard</Button>
					<Button variant="outline" onClick={() => navigate(PATHS.LANDING)}>Home</Button>
				</div>
			</div>
		</div>
	);
}
